<template>
    <div class="table__row">
        <div class="table__row__item table__row__item_name">
            <div class="name">
                {{ user.profilename }}
            </div>
            <div class="role-status">
                <span class="role">
                    {{ user.role }}
                </span>
                <span class="status" v-if="user.pending">
                    Pending
                </span>
            </div>
        </div>
        <div class="table__row__item table__row__item_email">
            {{ user.email }}
        </div>
        <div class="table__row__item table__row__item_apps">
            <div
                v-for="(item, itemIndex) in activeApps"
                :key="itemIndex"
                :style="{backgroundImage: `url('${item.logo_small}')`}"
                :class="{active: item.isActive}"
                class="unit"
            ></div>
        </div>
        <div class="table__row__item">
            <template v-if="areAttributesWithoutFilters">All</template>
            <template v-else>Selected</template>
        </div>
        <div class="table__row__item">
            {{ activeEvents.length }}
        </div>
        <div class="table__row__item table__row__item_buttons">
            <div
                v-if="user.isEditable"
                class="button button_edit"
                @click="editUser"
            ></div>
            <div
                v-if="user.isEditable"
                class="button button_delete"
                @click="deleteUser"
            ></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Row',
        props: {
            user: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },
        computed: {
            activeApps() {
                return this.user.apps.items.filter((item) => item.isActive);
            },
            activeEvents() {
                return this.user.events.items.filter((item) => item.isActive);
            },
            areAttributesWithoutFilters() {
                return this.user.features.items.filter((item) => item.isAttributeWithOptions).every((att) => att.switcherOptions.All.isSelected);
            },
        },
        methods: {
            editUser() {
                this.$emit('editUser');
            },
            deleteUser() {
                this.$emit('deleteUser');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .table__row {
        height: fit-content;
        min-height: 60px;
        display: grid;
        grid-template-columns: 1.7fr 2.33fr 1.73fr 1.2fr 1.3fr 1fr;
        padding: 0 22px;
        border-bottom: 1px solid rgba(96, 137, 231, 0.2);
        
        &:last-child {
            border-bottom: none;
        }
        
        &__item {
            text-align: left;
            padding: 14px 0;
            
            &_email {
                width: 200px;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            
            &_name {
                .role-status {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 3px;
                    color: #3F3F40;
                    font-size: 12px;
                    line-height: 15px;
                    padding-right: 20px;
                    
                    .role {
                        color: #3F3F40;
                    }
                    
                    .status {
                        color: $negative-color;
                    }
                }
            }
            
            &_apps {
                display: flex;
                max-width: 120px;
                flex-wrap: wrap;
                
                .unit {
                    width: 20px;
                    height: 20px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    margin-right: 10px;
                    border-radius: 4px;
                    margin-bottom: 5px;
                }
                
            }
            
            &_buttons {
                display: flex;
                padding: 14px;
                justify-content: flex-end;
                
                .button {
                    cursor: pointer;
                    
                    &_edit {
                        width: 18px;
                        height: 20px;
                        background-position: 0 0;
                        background-repeat: no-repeat;
                        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDEyIDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+OTFEM0FFQ0UtMjU4RS00N0JBLUI1NEQtNUE5N0I5MURGNTkwQDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9mb3JtdWxhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjIuMDAwMDAwLCAtMTIuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxnIGlkPSJtZW51X3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCA5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJ0YWJfb3BlbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMDAwMDAwLCAyLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iaWNvbi9wZW4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNSwxMS41IEw5LjUsMTEuNSBMOS41LDIgQzkuNSwxLjE3MTU3Mjg4IDguODI4NDI3MTIsMC41IDgsMC41IEw3LDAuNSBDNi4xNzE1NzI4OCwwLjUgNS41LDEuMTcxNTcyODggNS41LDIgTDUuNSwxMS41IFogTTkuMzEwMzk3OTYsMTMuNSBMNS42ODk2MDIwNCwxMy41IEM2LjM3OTMxNzk1LDE1LjUxMDg0OSA3LjA0MDIwMzMsMTYuNSA3LjUsMTYuNSBDNy45NTk3OTY3LDE2LjUgOC42MjA2ODIwNSwxNS41MTA4NDkgOS4zMTAzOTc5NiwxMy41IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNTAwMDAwLCA4LjUwMDAwMCkgcm90YXRlKDM1LjAwMDAwMCkgdHJhbnNsYXRlKC03LjUwMDAwMCwgLTguNTAwMDAwKSAiPjwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                        margin-right: 27px;
                    }
                    
                    &_delete {
                        width: 16px;
                        height: 16px;
                        background-position: 0 0;
                        background-repeat: no-repeat;
                        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                    }
                }
            }
        }
    }

</style>